import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';

import Modal from 'components/shared/DesignSystem/Modal';
import { Text } from 'components/projects/taskList/sharedStyles';
import TASK_LIST_DELETE from 'components/projects/taskList/gql/taskListDelete.graphql';
import { getGqlErrors } from 'components/projects/taskList/helpers';
import TaskListError from 'components/projects/taskList/components/TaskListError';
import { Button } from '@companycam/slab-web';

const messages = defineMessages({
  deleteTaskListTitle: {
    id: 'Projects.taskList.deleteTitle',
    defaultMessage: 'Delete List',
    description: 'Delete title for task list',
  },
  deleteTaskListBody: {
    id: 'Projects.taskList.deleteBody',
    defaultMessage:
      'Are you sure you want to delete this checklist? You cannot undo this action.',
    description: 'Delete body for task list',
  },
  deleteTaskListError: {
    id: 'Projects.taskList.deleteError',
    defaultMessage: 'There was an error deleting the checklist.',
    description: 'Error message when deleting a task list',
  },
});

const TaskListDeleteModal = ({
  taskListDeleteId,
  onRequestClose,
  isOpen,
  id,
}) => {
  const intl = useIntl();
  const [taskListDeleteError, setTaskListDeleteError] = useState({ msg: '' });
  const [deleteTaskListMutation] = useMutation(TASK_LIST_DELETE, {
    onCompleted: (data) => {
      const gqlErrors = getGqlErrors(data);
      if (!gqlErrors.length) {
        onRequestClose();
        window.Turbo.visit(`/projects/${id}/todos`);
      } else {
        setTaskListDeleteError({ msg: gqlErrors[0].message });
      }
    },
    onError: () => {
      setTaskListDeleteError({
        msg: intl.formatMessage(messages.deleteTaskListError),
      });
    },
  });

  const deleteTaskList = () => {
    deleteTaskListMutation({
      variables: {
        input: {
          id: taskListDeleteId,
        },
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={intl.formatMessage(messages.deleteTaskListTitle)}
      isClosable
    >
      <Text className="instructions">
        {intl.formatMessage(messages.deleteTaskListBody)}
      </Text>
      <div className="btn-container">
        <Button color="destroy" onClick={deleteTaskList}>
          <FormattedMessage id="Common.confirmDelete" />
        </Button>
        <Button onClick={onRequestClose}>
          <FormattedMessage id="Common.cancelDelete" />
        </Button>
      </div>
      {taskListDeleteError.msg.length ? (
        <TaskListError message={taskListDeleteError.msg} />
      ) : null}
    </Modal>
  );
};

TaskListDeleteModal.propTypes = {
  taskListDeleteId: PropTypes.string,
  onRequestClose: PropTypes.func,
  isOpen: PropTypes.bool,
  id: PropTypes.string,
};

export default TaskListDeleteModal;
